import Tracks from './tracks2'

export default Tracks
